import { pagedListWrapper, listItemWrapper } from '../../../api-client/wrappers'
import type { Starter } from '../../types/internal'
import type { MemberBox, BoxItem } from './types'

export default {
  factory: ({ apiClient, version }) => {
    const boxes = pagedListWrapper<'id', MemberBox>()(apiClient, {
      path: `/api/v${version}/store/boxes/member`,
      idKey: 'id'
    })

    const { getItem: getBoxByBoxMemberId } = listItemWrapper<MemberBox>(
      apiClient,
      { path: `/api/v${version}/store/boxes/member` }
    )

    return {
      boxes,
      getBoxByBoxMemberId,

      openBox: (boxMemberId: MemberBox['id'], boxItemId: BoxItem['id']) =>
        apiClient.post<MemberBox>(
          `/api/v${version}/store/boxes/member/${boxMemberId}/open/${boxItemId}`
        )
    }
  }
} satisfies Starter
